// WAENN — "Favoritos" en el desplegable de Ordenar por.
// No es un sort_by nativo de Shopify (no hay backend de favoritos), asi que
// lo resolvemos en cliente: al seleccionarlo, reordena las tarjetas visibles
// dejando primero las que el usuario ha guardado (icono de marcador
// relleno), sin recargar ni disparar el fetch de filtros de Dawn.

function waennApplyFavoritesSort() {
  var grid = document.querySelector('#product-grid');
  if (!grid) return;
  var items = Array.prototype.slice.call(grid.children);
  var saved = items.filter(function (li) {
    return li.querySelector('.card.is-saved');
  });
  var unsaved = items.filter(function (li) {
    return !li.querySelector('.card.is-saved');
  });
  saved.concat(unsaved).forEach(function (li) {
    grid.appendChild(li);
  });
}

function waennFavoritesRadioChecked() {
  var radio = document.getElementById('WaennSortFavorites');
  return !!(radio && radio.checked);
}

// Interceptar en fase de captura para que Dawn (facets.js) no intente
// enviar "waenn_favorites_sort" como si fuera un filtro real.
document.addEventListener(
  'change',
  function (e) {
    if (e.target && e.target.id === 'WaennSortFavorites') {
      e.stopPropagation();
      waennApplyFavoritesSort();
    }
  },
  true
);

// Si el usuario guarda/quita un producto de favoritos mientras "Favoritos"
// esta activo, reordenar de nuevo para reflejar el cambio al instante.
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('.card__save-btn');
  if (!btn) return;
  if (waennFavoritesRadioChecked()) {
    setTimeout(waennApplyFavoritesSort, 0);
  }
});
